export default {
  title: 'Provedores',
  description: 'Cadastre os sistemas e serviços externos que podem ser usados pelas funcionalidades da plataforma e defina onde e para que cada um está disponível.',
  labels: {
    new: 'Novo Provedor',
  },
  groups: {
    identification: 'Identificação e operação',
    countries: 'Países',
    capabilities: 'Recursos oferecidos',
  },
  fields: {
    name: 'Nome',
    code: 'Código técnico',
    priority: 'Prioridade',
    enabled: 'Habilitado',
    country: 'País',
    capability: 'Recurso oferecido',
  },
  countries: {
    title: 'Países atendidos',
    description: 'Defina em quais países este provedor pode ser utilizado.',
    labels: {
      new: 'Novo País',
    },
  },
  capabilities: {
    title: 'Recursos oferecidos',
    description: 'Informe quais operações ou recursos este provedor disponibiliza ao sistema.',
    labels: {
      new: 'Nova Capability',
    },
  },
  errors: {
    codeInvalid: 'Informe um código técnico em snake_case, começando por uma letra.',
    nameRequired: 'Informe o nome do provider.',
    priorityInvalid: 'A prioridade deve ser um número inteiro maior ou igual a zero.',
    countryInvalid: 'Informe um país válido.',
    capabilityInvalid: 'Informe uma capability em snake_case, começando por uma letra.',
  },
};
